// src/components/VideoPlayer.jsx
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { saveAs } from 'file-saver';

export default function VideoPlayer({ url, title,exerciseId }) {
  console.log(url);
  const [localUrl, setLocalUrl] = useState(null);
  const isGif = url?.toLowerCase().endsWith('.gif');

  useEffect(() => {
    const cached = localStorage.getItem(title);
    if (cached) {
      setLocalUrl(cached);
    }
  }, [title]);

  const downloadVideo = async () => {
    try {
      const res = await fetch(url);
      const blob = await res.blob();
      const file = new File([blob], `${title}.gif`, { type: 'image/gif' });

      saveAs(file);
      const localURL = URL.createObjectURL(blob);
      setLocalUrl(localURL);
      localStorage.setItem(title, localURL);
    } catch {
      alert('دانلود ویدیو با خطا مواجه شد');
    }
  };
const handleReport = async (type) => {
  try {
    const res = await fetch(`https://api.mogym.ir/api/video/report`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`, // اگه نیاز هست
      },
      body: JSON.stringify({
        exerciseId,     // آیدی حرکت
        type,           // 'Broken' یا 'Incorrect'
      })
    });

    if (res.ok) {
      alert('گزارش شما ثبت شد. ممنون از همکاری‌تان!');
    } else {
      alert('ثبت گزارش با خطا مواجه شد.');
    }
  } catch {
    alert('ارتباط با سرور برقرار نشد.');
  }
};

  return (
    <div className="my-3">
      {isGif ? (
        <img
          src={localUrl || url}
          alt={title}
          style={{ width: '100%', height: 'auto', borderRadius: '12px' }}
        />
      ) : (
        <ReactPlayer
          url={localUrl || url}
          controls
          width="100%"
          height="200px"
          style={{ borderRadius: '12px', overflow: 'hidden' }}
        />
      )}
<button
  onClick={() => handleReport('Broken')}
  className="mt-2 px-3 py-1 text-xs bg-red-600 text-white rounded-xl ml-2"
>
  گزارش خرابی ویدیو
</button>

<button
  onClick={() => handleReport('Incorrect')}
  className="mt-2 px-3 py-1 text-xs bg-yellow-500 text-white rounded-xl"
>
  گزارش ویدیوی اشتباه
</button>
      {/* {!localUrl && (
        <button
          onClick={downloadVideo}
          className="mt-2 px-4 py-1 text-sm bg-green-600 text-white rounded-xl"
        >
          دانلود برای استفاده آفلاین
        </button>
      )} */}
    </div>
  );
}
